exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mod-success{\n  background-color:#91d34d !important;\n  border-color:#91d34d !important;\n  color:rgb(255, 255, 255);\n}\n.mod-warning{\n  background-color:#f4d037 !important;\n  border-color:#f4d037 !important;\n  color:rgb(255, 255, 255);\n}\n.mod-default{\n  background-color:#bcbcbc !important;\n  border-color:#bcbcbc !important;\n  color:rgb(255, 255, 255);\n}\n", ""]);

// exports
